import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  icon: { marginRight: 6, fontSize: 20, padding: 0 },
  ratePlan: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr 2fr',
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',

      marginBottom: 8,
      border: `1px solid ${theme.palette.grey[400]}`
    },
    background: theme.palette.background.default
  },
  ratePlanDisabled: { opacity: '50%' },
  left: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: 16,
    border: `1px solid ${theme.palette.grey[200]}`,
    background: theme.palette.background.default
  },
  ratePlanTitle: { display: 'flex', alignItems: 'center' },
  policy: { display: 'flex', alignItems: 'center', margin: '2px 0' },
  payMentTermRow: {
    display: 'flex',
    alignItems: 'center',
    background: theme.palette.grey[200],
    padding: 4,
    borderRadius: 4,
    width: 'fit-content'
  },
  redIcon: {
    color: theme.palette.error.main,
    fontSize: 16,
    marginRight: 4,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    }
  },
  blueIcon: { color: theme.palette.info.main, fontSize: 16, marginRight: 4 },
  greenIcon: {
    color: theme.palette.secondary.main,
    fontSize: 16,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    },
    marginRight: 4
  },
  yellowIcon: {
    color: theme.palette.warning.main,
    fontSize: 16,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    },
    marginRight: 4
  },
  redtext: {
    color: theme.palette.error.main,
    marginRight: 8,
    fontWeight: 600,
    marginTop: 0.5
  },
  yellowText: {
    color: theme.palette.warning.main,
    marginRight: 8,
    fontWeight: 500
  },
  blueText: {
    color: theme.palette.info.main,
    marginRight: 8,
    fontWeight: 600,
    lineHeight: '20px'
  },
  greenIconText: {
    color: theme.palette.secondary.main,
    marginRight: 10,
    fontWeight: 600
  },
  blackText: {
    fontWeight: 500,
    color: theme.palette.text.primary
  },
  infoIcon: {
    fontSize: 12,
    padding: 0,
    marginRight: 4,
    alignSelf: 'center'
  },
  priceInfoIcon: {
    fontSize: 14,
    padding: 0,
    marginRight: 4,
    alignSelf: 'center'
  },
  middle: {
    display: 'grid',
    gridTemplateRows: '2fr 1fr 2fr',
    padding: 16,
    border: `1px solid ${theme.palette.grey[200]}`,
    background: theme.palette.background.default
  },
  price: { display: 'flex', alignItems: 'center' },
  discount: {
    background: theme.palette.grey[200],
    padding: 5,
    borderRadius: 7,
    width: 'fit-content'
  },
  iconText: {
    display: 'flex',
    verticalAlign: 'middle',
    fontWeight: 600,
    fontSize: 14,
    flex: 1,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12
    },
    color: theme.palette.text.primary
  },
  greyFontWeight: {
    color: theme.palette.grey[600],
    fontWeight: 500
    // margin: '2px 0',
    // [theme.breakpoints.down('sm')]: {
    //   fontSize: 11
    // }
  },
  tootalAmountText: {
    color: theme.palette.grey[600],
    margin: '2px 0'
  },
  greenText: { color: theme.palette.secondary.main, fontWeight: 400 },
  right: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    // [theme.breakpoints.down('sm')]: {
    //   display: 'grid',
    //   gridTemplateColumns: '1.5fr 1fr'
    // },
    padding: 16,
    border: `1px solid ${theme.palette.grey[200]}`,
    background: theme.palette.background.default
  },
  totalAmount: { display: 'flex', flexDirection: 'column', gap: 6 },
  formcontrol: {
    margin: 0,
    padding: 0,
    '& .MuiFormControlLabel-label': { fontSize: 12, marginLeft: 4 },
    '& .MuiCheckbox-root': {
      transform: 'scale(0.8)',
      padding: 0,
      marginLeft: -4
    }
  },
  checkBoxRoot: { padding: 0, margin: 0 },
  headerText: { color: theme.palette.grey[600], fontWeight: 600 },
  discountText: {
    color: theme.palette.error.main,
    fontWeight: 600,
    textDecoration: 'line-through'
  },
  tootalDiscount: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16
  },
  // The hint is a sibling of `.counter`, never a child of it. `.counter` is a
  // flex row (and a 2-column grid below `sm`) whose layout assumes exactly two
  // children; injecting a third full-width one squashes the checkbox and the
  // counter buttons on desktop and pushes the counter onto a second grid row on
  // mobile. This column wrapper preserves that contract.
  counterBlock: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    justifyContent: 'center'
  },
  availabilityHint: {
    display: 'block',
    width: '100%',
    marginTop: theme.spacing(0.5),
    textAlign: 'center',
    overflowWrap: 'anywhere',
    color: theme.palette.text.primary
  },
  counter: {
    display: 'flex',
    width: '100% ',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr'
    },
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    background: theme.palette.background.default,
    padding: 4,
    width: '100%'
  },
  header: { padding: 4, borderBottom: `1px dashed ${theme.palette.grey[400]}` },
  content: {
    display: 'flex',
    flexDirection: 'column',
    padding: '6px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 11
    },
    gap: 6,
    marginTop: 4,
    color: theme.palette.text.primary,
    fontWeight: 500,
    textAlign: 'left'
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column-reverse'
  },
  toolTipText: {
    fontWeight: 600,
    color: theme.palette.text.primary,
    direction: 'ltr'
  },
  dotText: {
    position: 'relative',
    paddingLeft: 8,
    fontWeight: 600,
    '&::before': {
      content: '""',
      position: 'absolute',
      left: -2,
      top: 7,
      transform: 'translateY(-50%)',
      width: 6,
      height: 6,
      marginRight: 6,
      borderRadius: '50%',
      backgroundColor: theme.palette.grey[600]
    }
  },
  dotTextPersian: {
    dir: 'rtl',
    alignItems: 'flex-end',
    position: 'relative',
    paddingLeft: 8,
    fontWeight: 600,
    '&::before': {
      content: '""',
      position: 'absolute',
      left: -2,
      top: 7,
      transform: 'translateY(-50%)',
      width: 6,
      height: 6,
      marginRight: 6,
      borderRadius: '50%',
      backgroundColor: theme.palette.grey[600]
    }
  },
  persian: { textAlign: 'right' },
  toolTip: {
    background: theme.palette.grey[300],
    minWidth: '320px',
    padding: 12
  },
  arrow: { color: theme.palette.grey[100] },
  mainDeadLineText: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    fontSize: '11px'
  },
  deadLineTextContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    marginTop: '2px',
    fontSize: '11px'
  },
  greyText: {
    color: theme.palette.grey[500],
    fontWeight: 500,
    [theme.breakpoints.down('sm')]: {
      fontSize: 11
    }
  },
  redPolicy: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  dateDetails: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'space-between',
    background: theme.palette.grey[200],
    padding: 4,
    marginTop: 3
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    marginTop: 2,
    gap: 4,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    flexShrink: 0
  },
  total: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    background: theme.palette.grey[200],
    marginTop: 6,
    padding: 8
  },
  providerRow: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    gap: 6
  },
  verticalAlign: { display: 'flex', verticalAlign: 'middle', fontSize: 14 },
  adopayLogo: { width: 40, height: 16, margin: '0 4px' },
  walletIcon: {
    fontSize: '16px',
    marginRight: 4,
    color: theme.palette.grey[800]
  },
  provider: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start'
    },
    gap: 4,
    marginBottom: 6
  },
  peymentTermName: { marginRight: 6, fontWeight: 500 },
  tooltipRow: { display: 'flex', flexDirection: 'row', alignItems: 'flex-end' },
  availibilityContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 8
  }
}))
export default useStyles
